export const notImplementedError = new Error('Not implemented in Campus Implementation');
